import React from 'react';
import SingleService from '../components/SingleServiceDetails';
import WorkWithUsCTA from '../components/WorkWithUsCTA';

const Service = () => {
  return (
    <>
      <SingleService />
      <WorkWithUsCTA />
    </>
  );
};

export default Service;